import store from "@/store"

export default {
    get application() {
        return store.state.application.data
    },

    set application(application) {
        store.commit("application/update", application)
    },

    get applyMode() {
        return store.state.application.applyMode
    },

    get resume() {
        return store.state.application.resume
    },

    get primaryLenderApplyMode() {
        return store.state.application.primaryLenderApplyMode
    },

    get selectedPaymentPlan() {
        return store.state.application.selectedPaymentPlan
    },

    get purchaserEnabled() {
        return this.application.purchaserEnabled
    },

    get purchaseAmountCents() {
        return this.application.purchaseAmountCents
    },

    get maxCalculatorDollars() {
        return store.state.application.maxCalculatorDollars
    },

    set purchaserEnabled(enabled) {
        store.commit("application/updatePurchaserEnabled", enabled)
    },

    set applyMode(mode) {
        store.commit("application/updateApplyMode", mode)
    },

    set selectedPaymentPlan(plan) {
        store.commit("application/updateSelectedPaymentPlan", plan)
    },

    set primaryLenderApplyMode(mode) {
        store.commit("application/updatePrimaryLenderApplyMode", mode)
    },

    set resume(resume) {
        store.commit("application/updateResume", resume)
    },

    set purchaseAmountCents(value) {
        store.commit("application/updatePurchaseAmountCents", value)
    },

    set maxCalculatorDollars(value) {
        store.commit("application/updateMaxCalculatorDollars", value)
    },

    set treatmentType(value) {
        store.commit("application/updateTreatmentType", value)
    },
}
